import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const projectStatusMasterService = {
  // Get all project status masters with pagination and filters
  getAllProjectStatusMasters: async (params = {}) => {
    try {
      const response = await api.get('/project-status-masters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching project status masters:', error);
      throw error;
    }
  },

  // Get project status master by ID
  getProjectStatusMasterById: async (id) => {
    try {
      const response = await api.get(`/project-status-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project status master:', error);
      throw error;
    }
  },

  // Create new project status master
  createProjectStatusMaster: async (data) => {
    try {
      const response = await api.post('/project-status-masters', data);
      return response.data;
    } catch (error) {
      console.error('Error creating project status master:', error);
      throw error;
    }
  },

  // Update project status master
  updateProjectStatusMaster: async (id, data) => {
    try {
      const response = await api.put(`/project-status-masters/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating project status master:', error);
      throw error;
    }
  },

  // Delete project status master (soft delete)
  deleteProjectStatusMaster: async (id) => {
    try {
      const response = await api.delete(`/project-status-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting project status master:', error);
      throw error;
    }
  },

  // Get project status master statistics
  getProjectStatusMasterStats: async () => {
    try {
      const response = await api.get('/project-status-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching project status master stats:', error);
      throw error;
    }
  }
};

export default projectStatusMasterService;